import { useClient } from "@adamlip/okeoke.client";
import { Image } from "@heroui/react";

export default function RafiVPos({ agent, selected }) {

    const { getName } = useClient();

    return (
        <div className="flex flex-col gap-1">
            <div className="">
                {getName(agent.name)}
            </div>
            <Image
                src="https://cdn.okeoke.io/brands/global/payments/rafivpos.png"
                className="mt-1"
                classNames={{ img: "object-contain" }}
                height="26px"
                alt="rafiVpos"
            />
        </div>
    )
}